import { gsap } from "gsap";
import Scrollbar from "smooth-scrollbar";
export default () => {
  const preloader = document.querySelector("[preloader-main]");
  const header = document.querySelector("[header]");
  const hero = document.querySelector(".default-hero");
  const hash = window.location.hash;
  const headerHeight = document.querySelector(".header").offsetHeight;
  const hide_animation = document.querySelector(".Hide");
  const ANIM_TIME = hide_animation ? 0 : 1;

  preloader ? preloaderHandle() : false;

  function preloaderHandle() {
    let scrollbar = Scrollbar.get(document.querySelector(".scroll-container"));
    stopPageScroll();
    gsap.to(preloader, {
      y: 0,
      duration: ANIM_TIME,
      ease: "power2.in",
      onComplete: () => {
        document.querySelector(".scroll-container").style.opacity = 1;
        const timeLine = gsap.timeline();
        timeLine.to(".preloader-img-box", {
          opacity: 1,
          duration: 0,
          ease: "none",
        });
        let stop = false;
        timeLine.to(".preloader-img-box", {
          opacity: 0,
          duration: ANIM_TIME / 2,
          delay: ANIM_TIME / 4,
          stagger: ANIM_TIME / 4,
          ease: "Circ.easeOut",
          onComplete: () => {
            const preloadLine = gsap.timeline();
            preloadLine.to(preloader, {
              opacity: 0,
              // y: '100%',
              duration: ANIM_TIME / 2,
              ease: "power2.in",
              onComplete: () => {
                preloader.style.zIndex = "-1";
                preloader.style.display = "none";
                gsap.to(header, {
                  opacity: 1,
                  zIndex: 1000,
                  duration: ANIM_TIME / 2,
                  delay: 0,
                  ease: "power1.inOut",
                });
                resumePageScroll();
              },

              onUpdate: () => {
                if (stop) return;

                if (
                  preloadLine.progress() > 1 - calculateHeroPercent() &&
                  hero
                ) {
                  stop = true;

                  gsap.to("[zoomable-item]", {
                    onStart: () => {
                      const heroTitles = document.querySelectorAll(
                        ".default-hero__title .inner"
                      );
                      heroTitles.forEach((el) => {
                        gsap.to(el, {
                          y: 0,
                          duration: ANIM_TIME,
                          delay: 0.3,
                          ease: "expo",
                        });
                      });
                    },
                    onComplete: () => {
                      scrollToAnchor();
                    },
                  });
                }
              },
            });
          },
        });
      },
    });

    function calculateHeroPercent() {
      if (!hero) {
        return 0;
      } else {
        return hero.offsetHeight / window.innerHeight;
      }
    }

    function stopPageScroll() {
      scrollbar.contentEl
        .querySelector(".scroll-inner-content")
        .classList.add("scroll-content--stoped");
      scrollbar.scrollTop = 0;
      scrollbar.update();
    }

    function resumePageScroll() {
      scrollbar.contentEl
        .querySelector(".scroll-inner-content")
        .classList.remove("scroll-content--stoped");
      scrollbar.update();
    }

    function scrollToAnchor() {
      if (hash) {
        const target = document.querySelector(hash);
        target
          ? scrollbar.scrollIntoView(target, {
              offsetTop: -scrollbar.containerEl.scrollTop + headerHeight,
            })
          : false;
      }
    }
  }
};

// DELAY TERMLY APPEARANCE
document.querySelector("body").onload = function () {
  setTimeout(function () {
    (document.querySelector("#termly-code-snippet-support").style.visibility =
      "visible"),
      (document.querySelector("#termly-code-snippet-support").style.opacity =
        "1");
  }, 7000);
};
